import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Search, RotateCcw, Coffee } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Search size={24} className="text-navy-950" data-id="element-193" />,
    title: 'Identificar Irritantes Nocturnos',
    desc: 'Descubre los "7 irritantes invisibles" en tu dieta diaria que actúan como diuréticos ocultos y estimulan la vejiga mientras intentas dormir.'
  }, {
    icon: <RotateCcw size={24} className="text-navy-950" data-id="element-194" />,
    title: 'Mejorar el Vaciado',
    desc: 'Aprende la técnica del "doble vaciado" para asegurar que tu vejiga quede realmente vacía antes de acostarte, reduciendo la necesidad de levantarte pronto.'
  }, {
    icon: <Coffee size={24} className="text-navy-950" data-id="element-195" />,
    title: 'Ordenar la Hidratación',
    desc: 'Implementa una ventana estratégica de líquidos. Aprende cuándo beber y cuándo detenerte para mantenerte hidratado sin comprometer tu descanso.'
  }];
  return <section className="bg-navy-900 py-20 md:py-28 relative text-cream-50" data-id="element-196">
      <div className="container mx-auto px-4" data-id="element-197">
        <div className="max-w-[900px] mx-auto" data-id="element-198">
          <FadeIn data-id="element-199">
            <div className="text-center mb-16" data-id="element-200">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-201">
                El enfoque del protocolo
              </h2>
              <p className="text-lg text-cream-100/80 max-w-2xl mx-auto leading-relaxed" data-id="element-202">
                Este método no depende de promesas vacías. Es un sistema
                práctico diseñado para calmar la vejiga y optimizar tu rutina
                nocturna a través de tres pilares fundamentales.
              </p>
            </div>
          </FadeIn>

          <div className="space-y-6 mb-16" data-id="element-203">
            {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-204">
                <div className="bg-navy-800 rounded-2xl p-6 md:p-8 border border-navy-700 flex flex-col sm:flex-row items-start sm:items-center gap-6 shadow-lg" data-id="element-205">
                  <div className="w-16 h-16 shrink-0 bg-gold-500 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-206">
                    {pillar.icon}
                  </div>
                  <div data-id="element-207">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-208">
                      {pillar.title}
                    </h3>
                    <p className="text-cream-100/70 leading-relaxed" data-id="element-209">
                      {pillar.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.3} data-id="element-210">
            <div className="flex justify-center" data-id="element-211">
              <Button href="#comprar" className="px-10 py-4" data-id="element-212">
                Ver el protocolo completo
              </Button>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}